import { Helmet } from "react-helmet"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import Header from "../../../components/Header"
import Layout from "../../../components/Layout"
import ThumbnailImage from "../../../images/thumbnails/g2_thumb.png"

export function Index() {
  return (
    <Layout
      title="G2 Live B2B Software Event Success with Premagic AI Photo Platform"
      description="G2 Live enhanced B2B software event networking and lead generation using Premagic’s AI-powered photo sharing and engagement technology."
      metaImage={ThumbnailImage}
      keywords={[
        "G2 Live case study, B2B software events, SaaS conference photos, software review platform events, B2B tech networking, enterprise software events, SaaS marketing conferences, software industry networking, B2B event technology, enterprise software marketing, SaaS community events, software buyer events, B2B photo sharing, enterprise event solutions, software conference management",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "G2 Live", url: "/case-study/g2-live/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "G2 Live B2B Software Event Success with Premagic AI Photo Platform",
            "description": "G2 Live enhanced B2B software event networking and lead generation using Premagic’s AI-powered photo sharing and engagement technology.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.G2_LIVE} />
    </Layout>
  )
}

export default Index
